module.exports = __webpack_public_path__ + "static/media/close-yellow.10ab2d79.svg";